import { Inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { UnitSetDefaultCommand, UnitSetDefaultCommandHandlerBase, UnitSetDefaultResponse } from '@skylab-shared/business';
import { HttpService } from '@skylab-shared/core';

@CommandHandlerFor(UnitSetDefaultCommand)
@Injectable({ providedIn: 'root'})
export class UnitSetDefaultCommandHandler {
    private commandHandler: UnitSetDefaultCommandHandlerBase;
    public constructor(
        @Inject(Http) http: HttpService
    ) {
        this.commandHandler = new UnitSetDefaultCommandHandlerBase(http);
    }

    public async handleAsync(cmd: UnitSetDefaultCommand): Promise<UnitSetDefaultResponse> {
        return await this.commandHandler.handleAsync(cmd);
    }
}
